import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Input, Button, Switch, Col, Row, InputNumber } from 'antd';
import { showMessage } from 'services/settings/message';
import { LOGGEDIN_USER_DATA } from 'global_config/constant-global';
import { createHospitalItems, updateHospitalItems } from 'services/settings/lookup_table/hospital';

const HospitalForm = ({ buttonNames, selecetedData, onDrawerClose, fetchData }) => {
	console.log(selecetedData);

	const onFinish = async values => {
		const payload = {
			hospitalName: values.hospitalName,
			hospitalAddress: values.hospitalAddress,
			hospitalContactNumber: values.hospitalContactNumber,
			isActive: values.isActive === true ? 1 : 0,
			psgcCode: values.psgcCode,
		};

		// console.log('payload =>', payload);

		if (buttonNames === 'ADD') {
			const createdHospitalResponse = await createHospitalItems(payload);
			// @ts-ignore
			if (createdHospitalResponse.status === 200) {
				showMessage('M0002', { onClose: () => { onDrawerClose(); fetchData(); } });
			}
		} else {
			payload.locationID = selecetedData.locationID;
			const updateHospitalResponse = await updateHospitalItems(payload);
			// @ts-ignore)
			if (updateHospitalResponse.status === 200) {
				showMessage('M0003', { onClose: () => { onDrawerClose(); fetchData(); } });
			}
		}
	};

	return (
		<div>
			<Form
				layout="vertical"
				onFinish={onFinish}
				initialValues={{
					hospitalName: selecetedData ? selecetedData.hospitalName : null,
					hospitalAddress: selecetedData ? selecetedData.hospitalAddress : null,
					hospitalContactNumber: selecetedData ? selecetedData.hospitalContactNumber : null,
					isActive: selecetedData ? (selecetedData.isActive === 1 ? true : false) : true,
					psgcCode: selecetedData ? selecetedData.psgcCode : null,
				}}
			>
				<Row>
					<Col span={4}>
						<Form.Item>
							<label>ACTIVE:</label>
						</Form.Item>
					</Col>

					<Col span={6}>
						<Form.Item name="isActive" valuePropName="checked">
							<Switch />
						</Form.Item>
					</Col>
				</Row>
				<Form.Item
					label="HOSPITAL NAME"
					name="hospitalName"
					rules={[{ required: true, message: 'Please input Hospital name' }]}
				>
					<Input />
				</Form.Item>
				<Form.Item
					label="ADDRESS"
					name="hospitalAddress"
					rules={[{ required: true, message: 'Please input Address' }]}
				>
					<Input />
				</Form.Item>
				<Form.Item
					label="CONTACT NUMBER"
					name="hospitalContactNumber"
					rules={[{ required: true, message: 'Please input Contact Number' }]}
				>
					<Input />
				</Form.Item>
				<Form.Item
					label="PSGC CODE"
					name="psgcCode"
					rules={[{ required: true, message: 'Please input Contact Number' }]}
				>
					<Input />
				</Form.Item>
				<section className="drawerFooter">
					<Button shape="round" onClick={onDrawerClose} style={{ marginRight: 8, width: 120 }}>
						CANCEL
					</Button>
					<Button type="primary" shape="round" style={{ margin: 10, width: 120 }} htmlType="submit">
						{buttonNames}
					</Button>
				</section>
			</Form>
		</div>
	);
};

export default HospitalForm;
